import { io } from "socket.io-client";
import { SOCKET_URL } from "./runtimeEnv.js";

const CONNECTION_CONFIG = {
    forceNew: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 2000,
    timeout: 10000,
    transports: ["websocket"],
    perMessageDeflate: false
};

export const SOCKET_CLIENT = io(
    SOCKET_URL,
    CONNECTION_CONFIG
);

/* ----------------- Debug listeners ----------------- */
SOCKET_CLIENT.on("connect", () => {
    console.log("✅ Socket connected successfully");
    // console.log("✅ Socket connected with ID:", SOCKET_CLIENT.id);
});

SOCKET_CLIENT.on("connect_error", (error) => {
    console.error("❌ Connection Error:", error.message);
});

SOCKET_CLIENT.on("disconnect", (reason) => {
    console.warn("⚠️ Socket disconnected:", reason);
});

SOCKET_CLIENT.on("reconnect_attempt", (attempt) => {
    console.log("🔄 Reconnection Attempt:", attempt);
});

SOCKET_CLIENT.on("reconnect", (attemptNumber) => {
    console.log("✅ Reconnected after", attemptNumber, "attempts");
});

SOCKET_CLIENT.on("reconnect_failed", () => {
    console.error("❌ Reconnection Failed");
});

/* ----------------- Emit helper ----------------- */
export const sendNotification = (notificationData) => {
    SOCKET_CLIENT.emit("notificationSend", notificationData, (error) => {
        if (error) {
            console.error("Socket emit error:", error);
        }
    });
};
